export default "__VITE_ASSET__C3NYc98c__"